module.exports = __webpack_public_path__ + "media/img/event/sponsor/mtsu_logo-08ad779cd716c53f80702f08bd944cde.png";